/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Passkey_Limit_ReachedInputs */

const en_error_passkey_limit_reached = /** @type {(inputs: Error_Passkey_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have the maximum of ${i?.max} passkeys.`)
};

/**
* | output |
* | --- |
* | "You have the maximum of {max} passkeys." |
*
* @param {Error_Passkey_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_passkey_limit_reached = /** @type {((inputs: Error_Passkey_Limit_ReachedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Limit_ReachedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_passkey_limit_reached(inputs)
});